import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import chatReducer from '../reducer/chat';
import menuReducer from '../reducer/menu';
import userInfoReducer from '../reducer/user';
import loadingReducer from '../reducer/loading';
import alertReducer from '../reducer/alert';

export const store = configureStore({
	reducer: {
		chat: chatReducer,
		menu: menuReducer,
		user: userInfoReducer,
		loading: loadingReducer,
		alert: alertReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;


export default store;